import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function CameraSelection({ value, onChange, disabled, multiple }) {

    const { CAMERAS } = window.conf
    const { t } = useTranslation()

    return (
        <FormControl 
            fullWidth 
            sx={{ pb: 2 }}
            disabled={disabled}
        >
            <InputLabel id='select-camera-label'>
                {t("events.camera")}{multiple ? "(s)" : ""}
            </InputLabel>

            <Select
                labelid='select-camera-label'
                id='select-camera'
                label={`${t("events.camera")}${multiple ? "(s)" : ""}`}
                value={value}
                onChange={event => onChange(multiple ? event.target.value : Number(event.target.value))}
                multiple={multiple}
            >
                {CAMERAS.map(({ id, name }) => (
                    <MenuItem key={id} value={id}>
                        {name || `${t("events.camera")} ${id + 1}`}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}